// extracted by mini-css-extract-plugin
export var boxItems = "_6r-1";
export var boxItemsLg = "_6r-2";
export var button = "_6r-7";
export var buttonHoverless = "_6r-9";
export var buttonLg = "_6r-8";
export var filterGroupBox = "_6r-0";
export var icon = "_6r-3";
export var iconSecondary = "_6r-6";
export var iconWrapper = "_6r-4";
export var iconWrapperLg = "_6r-5";
export var truncatedLabel = "_6r-a";